module.exports = __webpack_public_path__ + "img/HYPER_VARIATION_A1010.67a31da2.png";